import axios from "axios";

export function getParticipationList(co) {
    const config = {
        params: co,
    };
    return axios.get(process.env.VUE_APP_API_URL + "Participation/getallparticipations", config);
}

export function addParticipation(data) {
    return axios.post(process.env.VUE_APP_API_URL + "Participation/add", data);
}

export function updateParticipation(data) {
    return axios.put(process.env.VUE_APP_API_URL + "Participation/update", data);
}

export function deleteParticipation(id) {
    const config = {
        params: {
            id: id,
        },
    };
    return axios.delete(process.env.VUE_APP_API_URL + "Participation/deleted", config);
}
